import { css } from '@emotion/css';
import React from 'react';

export enum ColumnPaddingTop {
    Authenticated,
    UnAuthenticated,
}
export enum ColumnPaddingRight {
    TwoColumns,
}

interface ColumnBlockProps {
    isEnabled: boolean;
    hasSpacing: boolean;
    width: number;
    responsiveVariant?: string;
    paddingTop?: ColumnPaddingTop;
    paddingRight?: ColumnPaddingRight;
    children?: React.ReactNode;
}
export function ColumnBlock({
    isEnabled,
    hasSpacing,
    width,
    paddingTop,
    paddingRight,
    children,
}: ColumnBlockProps) {
    if (!isEnabled) {
        return null;
    }

    let columnPaddingTop = '';
    if (paddingTop === ColumnPaddingTop.Authenticated) {
        columnPaddingTop = 'authenticated';
    } else if (paddingTop === ColumnPaddingTop.UnAuthenticated) {
        columnPaddingTop = 'unauthenticated';
    }

    let columnPaddingRight = '';
    if (paddingRight === ColumnPaddingRight.TwoColumns) {
        columnPaddingRight = '2cols';
    }
    return (
        <div
            className={css([
                {
                    float: 'left',
                    height: '100%',
                    overflow: 'visible',
                },
                hasSpacing && {
                    marginRight: '32px',
                },
                columnPaddingTop === 'unauthenticated' && {
                    paddingTop: '80px',
                },
                columnPaddingTop === 'authenticated' && {
                    paddingTop: '56px',
                },
                columnPaddingRight === '2cols' && {
                    paddingRight: '80px',
                },
            ])}
            style={{
                width: width,
            }}
        >
            {children}
        </div>
    );
}
